import { Button } from "react-admin";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import React, { useState } from "react";
import { changeSelectedRoute } from "../../../redux/navmode.action";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { useDispatch } from "react-redux";
import { useFormState } from "react-final-form";

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
});

interface BackButtonProps {
  setIsOpenDetailRoute: any;
}

const BackButton: React.FC<BackButtonProps> = ({ setIsOpenDetailRoute }) => {
  const [open, setOpen] = useState<boolean>(false);

  // true if the form values are the same as the initial values. false otherwise.
  const { pristine } = useFormState();

  const classes = useStyles();
  const dispatch = useDispatch();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleBackButton = () => {
    setIsOpenDetailRoute(false);
    dispatch(changeSelectedRoute(null));
    handleClose();
  };

  return (
    <>
      <IconButton
        aria-label="Back"
        size="medium"
        onClick={!pristine ? handleOpenDialog : handleBackButton}
        style={{ padding: "10px" }}
      >
        <KeyboardBackspaceIcon fontSize="inherit" />
      </IconButton>

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Warning</DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure you want to go back? Any unsaved changes will be lost.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Cancel" />
          <Button onClick={handleBackButton} color="primary" label="Proceed" />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BackButton;
